define('order_wizard_paymentmethod_threedsecure_module.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('order_wizard_paymentmethod_threedsecure_module', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"order-wizard-paymentmethod-threedsecure-module\"> "
    + ((stack1 = _nl_(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? _nl_(depth0,"threeDSecureError") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":61},"end":{"line":1,"column":192}}})) != null ? stack1 : "")
    + " </div> ";
},"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " <div class=\"alert alert-error\"> "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? _nl_(depth0,"threeDSecureError") : depth0)) != null ? _nl_(stack1,"errorMessage") : stack1), depth0))
    + " </div> ";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return " "
    + ((stack1 = ((helper = (helper = _nl_(helpers,"iframe") || (depth0 != null ? _nl_(depth0,"iframe") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"iframe","hash":{},"data":data,"loc":{"start":{"line":1,"column":172},"end":{"line":1,"column":184}}}) : helper))) != null ? stack1 : "")
    + " ";
},"useData":true}, 'extensions/SC/HorizonEdits/3.0.1/', 'extensions/SC/HorizonEdits/3.0.1/', Handlebars);
});